module.exports = __webpack_public_path__ + "static/media/experimentos.e51692d3.jpg";